import React, { useEffect, useCallback, Fragment, useRef, useState } from 'react';
import Modal from "components/common/modal";
import { useDispatch, useSelector } from 'react-redux'
import { mergeLayout } from 'actions/livefeed'
import { setMapConfigMode } from 'actions/livefeed/steerpathMapActions'
import { setStepNumberState, handleClearHistory } from 'actions/livefeed/historyActions'
import Select from 'react-select';
import CustomTickBox from 'components/common/CustomTickBox'
import * as a from 'actions/livefeedapi';
import { detectLivefeedV2 } from 'components/pages/livefeed/utils'
import SnapshotSlidesCarousel from './SnapshotSlidesCarousel'
import './index.less'

export default () => {
    //-------------------------------------------Choose layout template functions hanlde -----------------------------------
    // fetchTemplate once
    const fetchTemplateOnce = useCallback(() => {
        dispatch(a.fetchTemplate());
    }, [dispatch])

    useEffect(() => {
        fetchTemplateOnce()
    }, [fetchTemplateOnce])

    const templatesListModal = useRef(null)
    const [chosenTemplate, setChosenTemplate] = useState(null)

    const [chosenLayout, setChosenLayout] = useState(null)
    const [layoutAllSlides, setLayoutAllSlides] = useState(false)

    const dispatch = useDispatch();
    const { mapConfigMode, stepNumberState, livefeedSlides, slideCurrentIndex } = useSelector(state => state.livefeededitor)
    const { templates } = useSelector(state => state.livefeedAPIReducer)

    const handleMergeLayout = useCallback((i, layout) => {
        dispatch(handleClearHistory(i))
        stepNumberState !== 0 && dispatch(setStepNumberState(0));
        dispatch(mergeLayout(i, layout))
    }, [dispatch, stepNumberState])

    function mergeLayoutHandle() {
        const layout = chosenLayout
        console.log("chosenLayout", chosenLayout)
        if (layout) {
            if (layoutAllSlides) {
                for (let i = 0; i < livefeedSlides.length; i++) {
                    // assign current floorplanOptions with index to layout.floorplanOptions
                    const currentFloorplanOptions = livefeedSlides[i].floorplanOptions
                    layout.floorplanOptions = currentFloorplanOptions
                    // keep style color only
                    let newTextContainers = []
                    for (let n = 0; n < livefeedSlides[i].textContainer.length; n++) {
                        let textContainer = livefeedSlides[i].textContainer[n]
                        textContainer.color = layout.textContainer[0].color
                        newTextContainers.push(textContainer)
                    }
                    layout.textContainer = newTextContainers
                    // Merge layout to the right slideType
                    switch (layout.slideType) {
                        case "summary":
                            livefeedSlides[i].slideType === "summary" && handleMergeLayout(i, layout)
                            break
                        case "locationsList":
                            livefeedSlides[i].slideType === "locationsList" && handleMergeLayout(i, layout)
                            break;
                        case "slideshow": livefeedSlides[i].slideType === "slideshow" && handleMergeLayout(i, layout)
                            break;
                    }
                }
            } else {
                // assign current floorplanOptions to layout.floorplanOptions
                const currentFloorplanOptions = livefeedSlides[slideCurrentIndex].floorplanOptions
                layout.floorplanOptions = currentFloorplanOptions
                // keep style color only
                let newTextContainers = []
                for (let i = 0; i < livefeedSlides[slideCurrentIndex].textContainer.length; ++i) {
                    let textContainer = livefeedSlides[slideCurrentIndex].textContainer[i]
                    textContainer.color = layout.textContainer[0].color
                    newTextContainers.push(textContainer)
                }
                layout.textContainer = newTextContainers
                handleMergeLayout(slideCurrentIndex, layout)
            }
            // trigger rerender the map when merging layout
            if (mapConfigMode === "user_input") {
                dispatch(setMapConfigMode("map_interact")) // this won't rerender
            }
            dispatch(setMapConfigMode("user_input"))
        }
    }

    function selectCreateOptions() {
        let ar = []
        templates.map((x) => {
            if (detectLivefeedV2(x.data.livefeedSlides)) {
                return ar.push({
                    value: x.id,
                    label: x.name,
                    data: x.data
                })
            }
        });
        return ar;
    }

    const [currentSlideTypeState, setCurrentSlideTypeState] = useState(null)
    useEffect(() => {
        setCurrentSlideTypeState(livefeedSlides[slideCurrentIndex].slideType)
    }, [livefeedSlides, slideCurrentIndex,])

    const nodeMap = useSelector(state => state.overviewReducer.nodeMap)
    const sensorMap = useSelector(state => state.nodeReducer.map)
    return (
        <Fragment>
            <span className="stats-menu__list-item " onClick={() => templatesListModal.current.open()}>
                <div className="stats-menu-btn cursor--pointer">
                    <span className="cursor--pointer">
                        <i style={{ marginRight: 5 }} className="material-icons material-icons_size">insert_drive_file</i>
                        Choose Template layout
                            </span>
                </div>
            </span>
            <Modal
                ref={templatesListModal}
                clickButton={() => { templatesListModal.current.close(); mergeLayoutHandle() }}
                header="Choose layout template"
                buttonText="Confirm"
                buttonClass={`btn-success ${!chosenLayout ? 'btn-disabled' : ''}`}
                buttonHide={true}
                entry={null}
                className="livefeed-preview__floorplan-modal"
            >
                <div className="add-feed-modal">
                    <div>
                        <p>Please select a layout/template for your slide.</p>
                    </div>
                    {chosenTemplate &&
                        <Fragment>
                            <div className="floorplan-preview-carousel">
                                {livefeedSlides[slideCurrentIndex].slideType === currentSlideTypeState ?
                                    <SnapshotSlidesCarousel
                                        currentSlideTypeState={currentSlideTypeState}
                                        dispatch={dispatch}
                                        nodeMap={nodeMap}
                                        sensorMap={sensorMap}
                                        setChosenLayout={setChosenLayout}
                                        chosenTemplate={chosenTemplate}
                                        slideCurrentIndex={slideCurrentIndex}
                                    />
                                    : <p>There is no layout slide available for this slide  </p>
                                }
                            </div>
                            <br />
                        </Fragment>
                    }
                    <Select
                        autoFocus={true}
                        openOnFocus={true}
                        openOnClick={true}
                        closeOnSelect={true}
                        clearable={false}
                        onChange={(option) => setChosenTemplate(option)}
                        options={selectCreateOptions()}
                        placeholder="Select template for livefeed"
                        value={chosenTemplate}
                    />
                    {livefeedSlides[slideCurrentIndex].slideType === "slideshow" &&
                        <Fragment>
                            <br />
                            <p>Select this checkbox to apply layout to all slideshow slides</p>
                            <CustomTickBox
                                onClick={() => setLayoutAllSlides(!layoutAllSlides)}
                                label="Apply to all slideshow slides"
                                isActive={layoutAllSlides}
                            />
                        </Fragment>
                    }
                </div>
            </Modal>
        </Fragment >
    )
}




// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/TopMenuContainer/ChooseLayout/index.jsx